import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { DayDetailsStyle } from './DayDetails.style';
import RightIcon from "@material-ui/icons/ArrowForwardIosRounded";
import UnseenIcon from "@material-ui/icons/VisibilityOffRounded";
import NoEndTimeIcon from '@material-ui/icons/ArrowRightAlt';
import { Link } from 'react-router-dom';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import { isSameDay } from '@helpers/DateHelper';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { FamilyMemberType } from '@services/family/family.constants';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof DayDetailsStyle> {
  renderForDate:Date;
  event: IExternalCalenderEvent;
  localization: "se"|"en";
  barOneBackground?:React.CSSProperties;
  barTwoBackground?:React.CSSProperties;
  barThreeBackground?:React.CSSProperties;
  family:IFamilyMember[];
  userId:number;
}

interface IState {
  expanded: boolean;
}

class DayImportedEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      expanded: false,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {
    const {classes,event,renderForDate} = this.props;
    
    
    const tagged:IFamilyMember|undefined = this.background(event.tagged);
    const background:string = tagged?tagged.color:"#c3c3c3";
    const avatar = tagged
      ?<ImgAvatar altText={tagged.firstName} imgUrl={tagged.imageAvatar?tagged.avatarURL:undefined}
        imgName={tagged.avatar} style={{width:'18px', height:'18px', marginRight: '3px'}} color={tagged.color} key={tagged.id}/>
      :null;
    const startDate = new Date(event.startTime);
    let endDate = new Date(event.endTime);

    if (endDate.getHours() === 0 && endDate.getMinutes() === 0 && endDate.getSeconds() === 0 && endDate.getMilliseconds() === 0) {
      endDate= new Date(event.endTime - 1); 
    }

    const startToday = (startDate.getFullYear() === renderForDate.getFullYear() 
      && startDate.getMonth() === renderForDate.getMonth() 
      && startDate.getDate() === renderForDate.getDate());
    const endToday = (endDate.getFullYear() === renderForDate.getFullYear() 
      && endDate.getMonth() === renderForDate.getMonth() 
      && endDate.getDate() === renderForDate.getDate());

    const isFullDayEvent = (startToday && endToday && (event.endTime - event.startTime > (1000*60*60*22))) 
      || (startToday === false && endToday === false);

    let timeDetails:JSX.Element;
    if (isFullDayEvent) {
      timeDetails = (<div className={classes.eventTimeBoxPlacement}>
        <div className={classes.eventTimeBox} style={{color:styleColors.greyMedium3, fontWeight: 300}}>
          {tn.lang.calFullDay}
        </div>
      </div>);
    } else {
      timeDetails = (<div className={classes.eventTimeBoxPlacement}>
        <div className={classes.eventTimeBox}>
          {(startToday?(tn.formatTime(startDate)):endToday
            ?<NoEndTimeIcon style={{rotate: '90deg', height: '16px', margin: '0px 4px', color:styleColors.greyMedium3}}/>:" ")}
        </div>
        <div className={classes.eventTimeBox} style={(startToday && endToday)?{color:styleColors.greyMedium3, fontWeight: 300}:{}}>
          {endToday
            ?tn.formatTime(endDate)
            :startToday
              ?<NoEndTimeIcon style={{rotate: '90deg', height: '16px', margin: '0px 4px', color:styleColors.greyMedium3}}/>
              :tn.lang.calFullDay}
        </div>
      </div>);
    }

    let titleWeight = 300;

    if (event.tagged && event.tagged ===this.props.userId) {
      titleWeight = 500;
    } else if (event.tagged && event.tagged > 0) {
      let mycolor = "";

      const me = this.props.family.find((mem) => mem.id === this.props.userId);
      const ta = this.props.family.find((mem) => mem.id === event.tagged);

      if (me  && me.role === FamilyMemberType.PARENT && ta && ta.role === FamilyMemberType.CHILD) {
        mycolor = me.color;
        const iHaveCustody = (this.props.barOneBackground && this.props.barOneBackground.backgroundColor === mycolor)
          || (this.props.barTwoBackground && this.props.barTwoBackground.backgroundColor === mycolor)
          || (this.props.barThreeBackground && this.props.barThreeBackground.backgroundColor === mycolor);
        if (iHaveCustody) { 
          titleWeight = 500;
        }
      }
    }

    return (

        <div  className={classes.event} onClick={() => {this.setState({expanded:!this.state.expanded})}} id={"importedeventdetails-"+event.id}>
          <div className={classes.eventScheduleData} style={{maxWidth:'calc(100% - 17px)',minWidth:'calc(100% - 17px)'}}>
            <div className={classes.eventColorBand} style={{background}}/>
            <div className={classes.eventData} >
              {timeDetails}
              <div style={{display:'flex', flexDirection:'column', maxWidth: 'calc(100% - 64px)'}}>
                <div className={classes.eventItemTopRow} >
                  <div className={classes.eventDescBox} style={{fontWeight: titleWeight}}>
                    {avatar}
                    <span style={{overflow: 'hidden', whiteSpace: this.state.expanded?'normal':'nowrap', textOverflow: 'ellipsis'}}>
                    
                    {event.title}
                    </span>
                  </div>
                </div>  
                <div className={classes.eventItemRow} >
                  <div className={classes.eventDescBox} style={{maxHeight:(this.state.expanded?1000:12), overflow:'hidden', transition:'all 0.6s',
                    display:'flex', alignItems:'flex-start', flexDirection:'column'}}>
                    <span className={classes.eventDescriptionText} style={this.state.expanded?{whiteSpace:'pre-wrap',display: 'block'}:{}}>
                      {this.replaceURLs(event.description?event.description:"")}
                    </span>
                    <span className={classes.eventDescriptionText} style={{fontWeight: 600, marginTop: '10px', 
                      display:(this.state.expanded?'unset':'none')}}>
                      {event.internal === true?(tn.lang.calUrlInternal(event.shared)):(tn.lang.calUrlImp(event.shared))}
                    </span>
                  </div>
                </div>
                </div>
            </div>
            <div style={{marginLeft:'8px', alignSelf: this.state.expanded?'flex-start':'center', color: styleColors.greyMedium2, marginRight:'5px'}}>
              <RightIcon style={{rotate: this.state.expanded?'90deg':'0deg', transition:'all 0.3s'}}/>
            </div>
          </div>
          <div className={classes.eventScheduleBands}>
            <div className={classes.eventScheduleBand} style={this.props.barTwoBackground}/>
            <div className={classes.eventScheduleBand} style={this.props.barOneBackground}/>
            <div className={classes.eventScheduleBand} style={this.props.barThreeBackground}/>
          </div>
          <div className={classes.eventLine}/>
        </div>
    );
  }

  private background(tagged:number|undefined):IFamilyMember|undefined {
    if (tagged && tagged > 0) {
      return this.props.family.find((mem) => mem.id === tagged);
    }

    return undefined;
  }

  private replaceURLs(msg: string): Array<string | JSX.Element> {
    const urlRegex = new RegExp(/(https?:\/\/[^\s\,]+|www\.[^\s\,>\"]+|[^\s\,]+@[^\s\,]+)/g);
    const messageArray = msg.split(urlRegex);
    const result: Array<string | JSX.Element> = [];
    let index = 0;
    let msgLength = 0;
    for (const msgPart of messageArray) {
      if (!this.state.expanded && msgLength >= 30) {
        break;
      }
      if (urlRegex.test(msgPart)) {
        let hyperLink = "";
        if (msgPart.indexOf('@') > 0) {
          hyperLink = "mailto:" + msgPart;
        } else {
          hyperLink = new RegExp('^https?:\/\/').test(msgPart) ? msgPart : `http://${msgPart}`;
        }
        if (hyperLink.startsWith('https://varannanvecka.app/app')) {
          result.push(
            <Link key={`link-${index}`} to={hyperLink.substring(25)} style={{ display: 'inline' }}>{msgPart}</Link>
          );
        }
        else {
          result.push(
            <a key={`link-${index}`} href={hyperLink} className={this.props.classes.eventDescriptionLink}
              target="_blank" rel="noopener noreferrer">
              {msgPart}
            </a>);
        }
        msgLength = msgLength + msgPart.length;
      } else {
        // let fixedString = msgPart.replace(/ *\<[^>]*\> */g, "");
        let fixedString = msgPart.replace(/-::[\s\S]*?::-|<[\s\S]*?>|==|--|~~/g,"");
        fixedString = fixedString.replace(/[\r\n]+/g,"\r\n");
        if (fixedString.length > 30 && !this.state.expanded) {
          fixedString = fixedString.substring(0,30)+"...\r\n";
        }
        if (index === 0) {
          fixedString = fixedString.trimStart();
        }
        if (fixedString.length === 0) {
          continue;
        }
        msgLength = msgLength + fixedString.length;
        result.push(fixedString);
      }
      index++;
    }
    return result;
  }


}

export default withStyles(DayDetailsStyle)(DayImportedEvent);



// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/DayExternalEvent.tsx